class DownloadMediaStatus extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this._onStart = () => this._setMessage('Processing');
    this._onProgress = (e) => {
      const { total, progress } = e.detail;
      this._setMessage(`Preparing files (${Math.round(100 * progress / total)}%)`);
    };
    this._onEnd = () => this._setMessage('');

    document.addEventListener('zip-urls:start', this._onStart);
    document.addEventListener('zip-urls:progress', this._onProgress);
    document.addEventListener('zip-urls:end', this._onEnd);
    document.addEventListener('zip-urls:error', this._onEnd);
  }

  disconnectedCallback() {
    document.removeEventListener('zip-urls:start', this._onStart);
    document.removeEventListener('zip-urls:progress', this._onProgress);
    document.removeEventListener('zip-urls:end', this._onEnd);
    document.removeEventListener('zip-urls:error', this._onEnd);
  }

  _setMessage(message) {
    this.innerHTML = message;
  }
}

if (!customElements.get("download-media-status")) {
  customElements.define("download-media-status", DownloadMediaStatus);
}
